export default "__VITE_ASSET__BNqAjdSv__"